import React from 'react';
import { logger } from '@/utils/logger';
import { Link } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

export function ForgotPassword() {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) throw error;
      
      setSuccess(true);
      toast.success('Återställningslänk skickad till din e-post');
    } catch (error) {
      logger.error('Error requesting password reset:', error);
      toast.error('Det gick inte att skicka återställningslänken. Försök igen senare.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Återställ ditt lösenord
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Ange din e-postadress så skickar vi en återställningslänk
          </p>
        </div>

        {success ? (
          <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg p-4">
            <p className="text-center">
              Vi har skickat ett e-postmeddelande med en återställningslänk till {email}.
              <br />
              Kontrollera din inkorg och följ instruktionerna i meddelandet.
            </p>
            <div className="mt-4 text-center">
              <Link
                to="/login"
                className="text-sm font-medium text-green-600 hover:text-green-500"
              >
                Tillbaka till inloggning
              </Link>
            </div>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email-address" className="sr-only">
                E-postadress
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
                placeholder="E-postadress"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Skickar...' : 'Skicka återställningslänk'}
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/login"
                className="text-sm font-medium text-green-600 hover:text-green-500"
              >
                Tillbaka till inloggning
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
} 